// extracted by mini-css-extract-plugin
export default {"root":"SpacedSection-module--root--892c4","section":"SpacedSection-module--section--c77fd"};